<script>
import {Bar} from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    assetData: {},
  },
  watch: {
    assetData: function () {
      const chartData = {
        labels: ['기본요금', '전력량요금(합계)', '중부하 요금', '최대부하 요금', '경부하 요금', '환경비용 차감', '자동이체 할인', '연료비 조정액', '전력 기금', '당월 청구요금'],
        datasets: [
          {
            label: '컨설팅 전',
            borderWidth: 2,
            borderColor: '#91B24F',
            backgroundColor: 'rgba(145, 178, 79, 0.4)',
            data: [
              this.assetData.beforeBasic,
              this.sumBeforeLoad,
              this.assetData.beforeHeavyLoad,
              this.assetData.beforeMaxLoad,
              this.assetData.beforeLightLoad,
              this.assetData.beforeEnvironment,
              this.assetData.beforeAutoDiscount,
              this.assetData.beforeFuelAdjust,
              this.assetData.beforeElectricFund,
              this.assetData.beforeTotalBill
            ]
          },
          {
            label: '컨설팅 후(II)',
            borderWidth: 2,
            borderColor: '#42A2BF',
            backgroundColor: 'rgba(66,162,191,0.4)',
            data: [
              this.assetData.afterBasic1,
              this.sumAfterLoad1,
              this.assetData.afterHeavyLoad1,
              this.assetData.afterMaxLoad1,
              this.assetData.afterLightLoad1,
              this.assetData.afterEnvironment1,
              this.assetData.afterAutoDiscount1,
              this.assetData.afterFuelAdjust1,
              this.assetData.afterElectricFund1,
              this.assetData.afterTotalBill1
            ]
          },
          {
            label: '컨설팅 후(III)',
            borderWdith: 2,
            borderColor: '#C15856',
            backgroundColor: 'rgba(193,88,86,0.4)',
            data: [
              this.assetData.afterBasic2,
              this.sumAfterLoad2,
              this.assetData.afterHeavyLoad2,
              this.assetData.afterMaxLoad2,
              this.assetData.afterLightLoad2,
              this.assetData.afterEnvironment2,
              this.assetData.afterAutoDiscount2,
              this.assetData.afterFuelAdjust2,
              this.assetData.afterElectricFund2,
              this.assetData.afterTotalBill2
            ]
          }
        ],
      }

      const options = {
        scales: {
          yAxes: [
            {
              ticks: {
                callback: function (value) {
                  return value / 10000 + '만'
                }
              }
            }
          ]
        }
      }

      if (this.assetData.customerType === 1) {
        chartData.datasets.splice(2, 1)
      }


      this.renderChart(chartData, options)
    }
  },
  computed: {
    sumBeforeLoad: function () {
      return this.assetData.beforeHeavyLoad + this.assetData.beforeMaxLoad + this.assetData.beforeLightLoad + this.assetData.beforeEnvironment
    },
    sumAfterLoad1: function () {
      return this.assetData.afterHeavyLoad1 + this.assetData.afterMaxLoad1 + this.assetData.afterLightLoad1 + this.assetData.afterEnvironment1
    },
    sumAfterLoad2: function () {
      return this.assetData.afterHeavyLoad2 + this.assetData.afterMaxLoad2 + this.assetData.afterLightLoad2 + this.assetData.afterEnvironment2
    },
  },
  created: function () {
  },
  mounted: function () {
    const chartData = {
      labels: ['기본요금', '전력량요금(합계)', '중부하 요금', '최대부하 요금', '경부하 요금', '환경비용 차감', '자동이체 할인', '연료비 조정액', '전력 기금', '당월 청구요금'],
      datasets: [
        {
          label: '컨설팅 전',
          borderWidth: 2,
          borderColor: '#91B24F',
          backgroundColor: 'rgba(145, 178, 79, 0.4)',
          data: [
            this.assetData.beforeBasic,
            this.sumBeforeLoad,
            this.assetData.beforeHeavyLoad,
            this.assetData.beforeMaxLoad,
            this.assetData.beforeLightLoad,
            this.assetData.beforeEnvironment,
            this.assetData.beforeAutoDiscount,
            this.assetData.beforeFuelAdjust,
            this.assetData.beforeElectricFund,
            this.assetData.beforeTotalBill
          ]
        },
        {
          label: '컨설팅 후(II)',
          borderWidth: 2,
          borderColor: '#42A2BF',
          backgroundColor: 'rgba(66,162,191,0.4)',
          data: [
            this.assetData.afterBasic1,
            this.sumAfterLoad1,
            this.assetData.afterHeavyLoad1,
            this.assetData.afterMaxLoad1,
            this.assetData.afterLightLoad1,
            this.assetData.afterEnvironment1,
            this.assetData.afterAutoDiscount1,
            this.assetData.afterFuelAdjust1,
            this.assetData.afterElectricFund1,
            this.assetData.afterTotalBill1
          ]
        },
        {
          label: '컨설팅 후(III)',
          borderWdith: 2,
          borderColor: '#C15856',
          backgroundColor: 'rgba(193,88,86,0.4)',
          data: [
            this.assetData.afterBasic2,
            this.sumAfterLoad2,
            this.assetData.afterHeavyLoad2,
            this.assetData.afterMaxLoad2,
            this.assetData.afterLightLoad2,
            this.assetData.afterEnvironment2,
            this.assetData.afterAutoDiscount2,
            this.assetData.afterFuelAdjust2,
            this.assetData.afterElectricFund2,
            this.assetData.afterTotalBill2
          ]
        }
      ],
    }

    const options = {
      scales: {
        yAxes: [
          {
            ticks: {
              callback: function (value) {
                return value / 10000 + '만'
              }
            }
          }
        ]
      }
    }

    if (this.assetData.customerType === 1) {
      chartData.datasets.splice(2, 1)
    }


    this.renderChart(chartData, options)
  }
}

//
</script>
